
export const initialState = {
    items: [
        {modelNumber: '', unitPrice: '', quantity: '', discount: '', unitCost: '', doNotOrder: false, lockup: false},
    ],
    total: 0,
    notes: '',
    rates: '',
    salesTax: 0.00,
    deliveryFee: 10.00,
    deliveryCost: 0.00,
    deliveryFeeOverride: false,
    invoiceNumber: '',
    pcInvoiceNumber: '',
    clientPONumber: '',
    haulAway: false,
    haulAwayFee: 0,
    haulAwayCost: 0,
    walkUp: '',
    walkUpCharges: [],
    haulAwayQuantity: 1,
    walkUpQuantity: 1,
    walkupHaulawayUnits: 1,
    status: '',
    type: 'Invoice',
    creator: '',
    billTo: null,
    shipTo: null,
    contact: null,
}
